module.exports = __webpack_public_path__ + "img/galerie-3.48f1b25e.jpg";